import { openNativeModal } from 'components/Modal';
import security from 'stores/security';

export function openIRAWithdrawLimitsModal(onOk?: () => void) {
    // 非 IRA 账户不展示该弹窗
    if (!security.isIRAAccount) {
        return;
    }

    openNativeModal({
        maskClosable: false,
        closable: true,
        width: '100%',
        className: 'deposit-ira-widthdraw-limits-modal',
        component: props => (
            <div>
                <h3 className="modal-title">{__('IRA Distribution rules')}</h3>
                <div className="modal-content">
                    <div>
                        <div className="modal-content-title">{__('Traditional IRA')}</div>
                        <p className="modal-text">
                            {__(
                                "If you need to withdraw money from your traditional IRA before you've reached age 59 ½, you'll typically pay a 10% penalty on top of the expected income taxes you'll owe. Withdrawals after reaching age 59 ½ are generally taxed as ordinary income. Required minimum distributions begin at age 73. In certain IRS-approved situations, you may take early withdrawals from your traditional IRA without penalty. Check out qualifying "
                            )}
                            <a href="https://www.irs.gov/taxtopics/tc557">{__('exceptions')}</a>
                            {__('.')}
                        </p>
                    </div>
                    <div className="mt-4">
                        <div className="modal-content-title">{__('Roth IRA')}</div>
                        <p className="modal-text">
                            {__(
                                "Qualified withdrawals of Roth IRA contributions are always tax-and penalty-free. However, any earnings withdrawn early could be subject to both taxes and penalties, unless you've reached age 59½ and met the 5 year holding period requirement or you meet a qualifying "
                            )}
                            <a href="https://www.irs.gov/taxtopics/tc557">{__('exception')}</a>
                            {__('.')}
                        </p>
                    </div>
                </div>
                <button
                    className="modal-btn"
                    onClick={() => {
                        props.close();
                        onOk?.();
                    }}>
                    {__('Got it')}
                </button>
            </div>
        )
    }).result.finally(onOk);
}
